export const translations = {
    es: {
        nav: {
            home: "Inicio",
            about: "Sobre LS39",
            new: "Motos Nuevas",
            used: "Ocasión",
            products: "Productos Oficiales",
            products_acc: "Accesorios Oficiales",
            products_apparel: "Ropa y Complementos",
            products_parts: "Recambios Originales",
            service: "Reservar Cita Taller",
            contact: "Contacto",
            admin: "Admin",
        },
        hero: {
            overline: "Concesionario Oficial Yamaha · Mallorca",
            title_1: "Yamaha",
            title_2: "Hecha para Mallorca",
            subtitle:
                "María Horrach y su familia crearon LS39 en homenaje a Luis Salom — el concesionario Yamaha de referencia en Mallorca. Motos nuevas, de ocasión y taller especializado.",
            cta_primary: "Ver gama nueva",
            cta_secondary: "Reservar prueba",
        },
        sections: {
            featured: "Gama destacada",
            featured_desc:
                "Una selección de las máquinas más representativas del catálogo Yamaha 2026.",
            new_title: "Motos nuevas",
            new_desc: "Toda la gama Yamaha 2026 disponible en Mallorca.",
            used_title: "Ocasión seleccionada",
            used_desc:
                "Motos de segunda mano revisadas y certificadas por nuestro taller oficial.",
            service_title: "Servicio especializado",
            service_desc:
                "Taller especializado para que tu Yamaha rinda como el primer día. Cuidamos cada moto con criterio técnico y atención personalizada. Entendemos la mecánica, pero también entendemos la pasión por rodar. Revisamos tu moto con procesos claros y sin improvisaciones. Trabajamos para que cada intervención sume fiabilidad y tranquilidad.",
            service_long_es: "Mantenimiento periódico, diagnóstico y reparaciones con enfoque profesional. Preparamos tu moto para la ciudad, la carretera y el uso diario. Cuidamos desde la transmisión hasta la frenada y la suspensión. Comprobamos desgaste, ajustes y puntos críticos en cada entrada a taller. Buscamos soluciones rápidas, pero nunca a costa de hacerlas mal. Te explicamos qué necesita tu moto y por qué lo necesita. Queremos que sepas siempre qué se hace y qué se entrega. Nuestro objetivo es reducir tiempos muertos y devolverte la moto lista. Trabajamos pensando en seguridad, rendimiento y durabilidad. Sabemos lo importante que es una moto fiable para moverte cada día. Si tu Yamaha necesita una revisión, una reparación o una puesta a punto, estamos para ayudarte.",
            contact_title: "Hablemos",
            contact_desc:
                "Cuéntanos qué moto buscas o qué servicio necesitas. Te responderemos en menos de 24h.",
            about_title: "Mallorca, nuestra carretera",
            about_desc:
                "Desde Palma hasta Sa Calobra. Llevamos más de 20 años conduciendo, vendiendo y cuidando Yamahas en la isla.",
            no_bikes: "Ninguna moto coincide con este filtro.",
            years_on_island: "Años en la isla",
            bikes_sold: "Yamahas vendidas",
        },
        carousel: {
            ls_title: "Luis Salom 39. Un homenaje a la pasión: LS39 Motos",
            ls_subtitle: "«Nuestro hijo Luis Salom hubiera montado un concesionario así». Descubre la historia, el orgullo y el legado familiar detrás de nuestro espacio Yamaha en Palma.",
            ls_cta: "Descubre nuestra historia",
            dealer_title: "Concesionario Oficial Yamaha en Mallorca",
            dealer_subtitle: "Una propuesta de excelencia que aceptamos con orgullo. Descubre cómo la visión de Yamaha y el impulso de nuestra familia crearon LS39 Motos.",
            dealer_cta: "Nuestra historia oficial",
            team_title: "Equipo experto, servicio de primer nivel",
            team_subtitle: "En LS39 Motos ponemos tu pasión en manos de especialistas certificados por Yamaha. Pon a punto tu moto con los mejores.",
            team_cta: "Conoce a nuestro equipo",
        },
        service_cards: {
            overline: "Servicio Oficial Yamaha · Mallorca",
            workshop_overline: "Taller LS39",
            maintenance_title: "Mantenimiento",
            maintenance_desc: "Revisiones oficiales con piezas Yamaha originales.",
            itv_title: "ITV asistida",
            itv_desc: "Preparamos tu Yamaha para pasar la ITV sin sorpresas.",
            track_title: "Pista & Custom",
            track_desc: "Setups de circuito, mappings y trabajos a medida.",
            diag_title: "Diagnóstico OBD",
            diag_desc: "Diagnóstico electrónico Yamaha YDIS.",
        },
        products_page: {
            overline_acc: "Accesorios",
            overline_apparel: "Ropa",
            overline_parts: "Recambios · Servicio Autorizado Yamaha",
        },
        misc: {
            loading: "Cargando…",
            bike_moto: "Moto",
            scooter: "Scooter",
            all: "Todos",
            category: "Categoría",
            catalog_overline_used: "Mallorca · Ocasión",
        },
        bike: {
            from: "Desde",
            from_month: "Desde",
            per_month: "€/mes",
            finance_note: "Financiación orientativa a 60 meses. Consulta condiciones.",
            year: "Año",
            mileage: "Km",
            condition_new: "Nueva",
            condition_used: "Ocasión",
            view: "Ver detalle",
            specs: "Ficha técnica",
            gallery: "Galería",
            video: "Vídeo",
            test_ride: "Reservar prueba",
            ask: "Preguntar por esta moto",
            description: "Descripción",
            licence: "Carnet",
            type: "Tipo",
            financing: "Financiación a tu medida",
            financing_desc: "Cuotas adaptadas a partir de 12 meses. Consulta sin compromiso.",
            financing_cta: "Consultar financiación",
            trust_title: "Garantías de la unidad",
            trust_service: "Historial de revisiones",
            trust_keys: "llaves",
            trust_tyres: "Estado neumáticos",
            trust_itv: "Próxima ITV",
            trust_warranty: "Garantía",
            trust_financing: "Financiación disponible",
            trust_delivery: "Entrega a domicilio en Mallorca",
        },
        forms: {
            name: "Nombre",
            email: "Correo electrónico",
            phone: "Teléfono",
            message: "Mensaje",
            send: "Enviar",
            sending: "Enviando…",
            success: "¡Recibido! Te contactamos en breve.",
            preferred_date: "Fecha preferida",
            preferred_time: "Hora preferida",
            motorcycle_model: "Modelo de moto",
            service_type: "Tipo de servicio",
            book: "Reservar cita",
            test_ride_title: "Reservar una prueba",
            contact_title: "Formulario de contacto",
            service_title: "Reservar cita de servicio",
            select_bike: "Selecciona una moto",
            notes: "Notas adicionales",
        },
        footer: {
            address: "Gran Via Asima, 35 · 07009 Palma de Mallorca",
            hours: "Lun–Vie 8:00 – 16:00",
            phone: "+34 871 005 111",
            rights: "Todos los derechos reservados.",
            tagline: "Concesionario oficial Yamaha en Mallorca. Venta, ocasión y taller especializado.",
            dealer: "Distribuidor oficial Yamaha",
            whatsapp_msg: "Hola LS39, me gustaría más información sobre una Yamaha.",
        },
        admin: {
            login: "Iniciar sesión",
            email: "Correo",
            password: "Contraseña",
            dashboard: "Panel de administración",
            bikes: "Motos",
            leads: "Solicitudes",
            add_bike: "Añadir moto",
            edit_bike: "Editar moto",
            delete_confirm: "¿Eliminar esta moto?",
            logout: "Cerrar sesión",
            save: "Guardar",
            cancel: "Cancelar",
            updated: "Actualizado",
            created: "Creado",
            deleted: "Eliminado",
            no_leads: "Sin solicitudes.",
            invalid_credentials: "Credenciales incorrectas",
            featured_label: "Destacada en inicio",
        },
    },
    en: {
        nav: {
            home: "Home",
            about: "About LS39",
            new: "New Bikes",
            used: "Pre-Owned",
            products: "Official Products",
            products_acc: "Official Accessories",
            products_apparel: "Clothing & Accessories",
            products_parts: "Original Spare Parts",
            service: "Book Workshop",
            contact: "Contact",
            admin: "Admin",
        },
        hero: {
            overline: "Official Yamaha Dealer · Mallorca",
            title_1: "Yamaha",
            title_2: "Built for Mallorca",
            subtitle:
                "María Horrach and her family created LS39 as a tribute to Luis Salom — the reference Yamaha dealership in Mallorca. New bikes, pre-owned and specialised workshop.",
            cta_primary: "See new range",
            cta_secondary: "Book a test ride",
        },
        sections: {
            featured: "Featured line-up",
            featured_desc:
                "A curated selection of the most iconic machines in Yamaha's 2026 catalogue.",
            new_title: "New motorcycles",
            new_desc: "The full Yamaha 2026 range available in Mallorca.",
            used_title: "Curated pre-owned",
            used_desc:
                "Second-hand motorcycles inspected and certified by our official workshop.",
            service_title: "Specialised service",
            service_desc:
                "Specialized workshop to keep your Yamaha performing like new. We care for every bike with technical expertise and personalized attention. We understand mechanics, but we also understand the passion for riding. We service your bike with clear processes and no improvisations.",
            service_long_en: "Periodic maintenance, diagnostics and professional repairs. We prepare your bike for the city, the road and daily use. We take care of everything from the transmission to braking and suspension. We check wear, adjustments and critical points with every workshop visit. We seek quick solutions, but never at the expense of quality. We explain what your bike needs and why. We want you to always know what's being done and what you're getting back. Our goal is to minimize downtime and return your bike ready to go. We work with a focus on safety, performance and durability. If your Yamaha needs a service, repair or tune-up, we're here to help.",
            contact_title: "Let's talk",
            contact_desc:
                "Tell us which bike you're after or which service you need. We respond within 24h.",
            about_title: "Mallorca, our road",
            about_desc:
                "From Palma to Sa Calobra. Over 20 years riding, selling and caring for Yamahas on the island.",
            no_bikes: "No bikes match this filter.",
            years_on_island: "Years on the island",
            bikes_sold: "Yamahas sold",
        },
        carousel: {
            ls_title: "Luis Salom 39. A tribute to passion: LS39 Motos",
            ls_subtitle: "«Our son Luis Salom would have set up a dealership just like this». Discover the history, pride and family legacy behind our Yamaha space in Palma.",
            ls_cta: "Discover our story",
            dealer_title: "Official Yamaha Dealership in Mallorca",
            dealer_subtitle: "A proposal of excellence we accepted with pride. Discover how Yamaha's vision and our family's drive created LS39 Motos.",
            dealer_cta: "Our official story",
            team_title: "Expert team, first-class service",
            team_subtitle: "At LS39 Motos we put your passion in the hands of Yamaha-certified specialists. Get your bike tuned by the best.",
            team_cta: "Meet our team",
        },
        service_cards: {
            overline: "Official Yamaha Service · Mallorca",
            workshop_overline: "LS39 Workshop",
            maintenance_title: "Maintenance",
            maintenance_desc: "Official services with genuine Yamaha parts.",
            itv_title: "ITV assistance",
            itv_desc: "We prepare your Yamaha to pass the ITV without surprises.",
            track_title: "Track & Custom",
            track_desc: "Circuit setups, mappings and bespoke builds.",
            diag_title: "OBD Diagnostics",
            diag_desc: "Yamaha YDIS electronic diagnostics.",
        },
        products_page: {
            overline_acc: "Accessories",
            overline_apparel: "Apparel",
            overline_parts: "Parts · Authorised Yamaha Service",
        },
        misc: {
            loading: "Loading…",
            bike_moto: "Motorcycle",
            scooter: "Scooter",
            all: "All",
            category: "Category",
            catalog_overline_used: "Mallorca · Pre-owned",
        },
        bike: {
            from: "From",
            from_month: "From",
            per_month: "€/mo",
            finance_note: "Indicative 60-month financing. Conditions apply.",
            year: "Year",
            mileage: "Km",
            condition_new: "New",
            condition_used: "Pre-Owned",
            view: "View details",
            specs: "Technical spec",
            gallery: "Gallery",
            video: "Video",
            test_ride: "Book test ride",
            ask: "Ask about this bike",
            description: "Description",
            licence: "Licence",
            type: "Type",
            financing: "Tailored financing",
            financing_desc: "Monthly plans from 12 months. No-obligation quote.",
            financing_cta: "Ask about financing",
            trust_title: "Unit guarantees",
            trust_service: "Service history",
            trust_keys: "keys",
            trust_tyres: "Tyre state",
            trust_itv: "Next ITV",
            trust_warranty: "Warranty",
            trust_financing: "Financing available",
            trust_delivery: "Home delivery in Mallorca",
        },
        forms: {
            name: "Name",
            email: "Email",
            phone: "Phone",
            message: "Message",
            send: "Send",
            sending: "Sending…",
            success: "Got it! We'll be in touch soon.",
            preferred_date: "Preferred date",
            preferred_time: "Preferred time",
            motorcycle_model: "Bike model",
            service_type: "Service type",
            book: "Book appointment",
            test_ride_title: "Book a test ride",
            contact_title: "Contact form",
            service_title: "Book service appointment",
            select_bike: "Pick a bike",
            notes: "Additional notes",
        },
        footer: {
            address: "Gran Via Asima, 35 · 07009 Palma de Mallorca",
            hours: "Mon–Fri 8:00 – 16:00",
            phone: "+34 871 005 111",
            rights: "All rights reserved.",
            tagline: "Official Yamaha dealer in Mallorca. Sales, pre-owned and specialised workshop.",
            dealer: "Official Yamaha dealer",
            whatsapp_msg: "Hi LS39, I'd like more information about a Yamaha.",
        },
        admin: {
            login: "Sign in",
            email: "Email",
            password: "Password",
            dashboard: "Admin dashboard",
            bikes: "Bikes",
            leads: "Leads",
            add_bike: "Add bike",
            edit_bike: "Edit bike",
            delete_confirm: "Delete this bike?",
            logout: "Sign out",
            save: "Save",
            cancel: "Cancel",
            updated: "Updated",
            created: "Created",
            deleted: "Deleted",
            no_leads: "No leads yet.",
            invalid_credentials: "Invalid credentials",
            featured_label: "Featured on home",
        },
    },
};
